var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-table',{attrs:{"url":"/api/v1/circularMail","appends":['sender_info'],"filter":[
    {
      name: 'with',
      value: ['circularMailMessages']
    },
    {
      name: 'take',
      value: '10'
    }
  ],"attributes":[
    {
      attribute: 'id',
      name: 'ID'
    },
    {
      attribute: 'sender_info',
      name: 'Absender',
      type: 'ProfileCell',
      sortable: false
    },
    {
      firstAttribute: 'receiver_count_send',
      secondAttribute: 'receivers_count',
      attribute: 'id',
      name: 'Status',
      type: 'CircularMailStatusCell',
      sortable: false
    },
    {
      attribute: 'dialogs',
      name: 'Nachricht',
      type: 'ExpandableIdCell',
      sortable: false
    },
    {
      name: 'Gelesen / Geantwortet',
      type: 'CircularMailReadCell'
    },
    {
      attribute: 'send_at',
      name: 'Versendet',
      type: 'CountdownCell',
      checkAttribute: 'sent'
    },
    {
      attribute: 'created_at',
      name: 'Angelegt am',
      type: 'DateTimeCell'
    },
    {
      name: 'Aktionen',
      type: 'CircularMailActionCell'
    }
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }